module.exports = __webpack_public_path__ + "static/media/triangolo_verde_ristorante.cdb07c45.svg";